import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';

import './events.css';


export class AutoCloseButton extends Component {

    constructor(props) {
        super(props);
        let event = this.props.receivedMessage.package.event;

        this.state = {
            countDown: event.type.display_time
        };
        this.countdownTimer = null;
    }

    componentDidMount() {
        this.countdownLoop();
    }

    componentWillUnmount() {
        if (this.countdownTimer) {
            clearTimeout(this.countdownTimer);
        }
    }

    setCountdown = () => {
        this.setState({ countDown: --this.state.countDown },
            this.countdownLoop);
    };

    countdownLoop = () => {
        if (this.countdownTimer) {
            clearTimeout(this.countdownTimer);
        }
        if (this.state.countDown === 0) {
            this.props.eventComplete();
        }
        this.countdownTimer = setTimeout(this.setCountdown, 1000);
    }


    stopTimer = () => {
        if (this.countdownTimer) {
            clearTimeout(this.countdownTimer);
        }
    };

    render() {
        return <>
            <Button
                variant={'hex'}
                onClick={this.stopTimer}
            >Wait</Button>
            <Button
                variant={'deep'}
                onClick={this.props.eventComplete}
            >Close ({this.state.countDown}s)</Button>
        </>;

    }
}


export class DefaultEventComponent extends Component {

    render() {
        return <></>;
    }

}


export default class DefaultEventModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            show: true
        };
    }

    eventComplete = () => {
        this.props.eventComplete();
    };

    hide = () => {
        this.setState({ show: false }, this.eventComplete);
    };

    render() {

        let event = this.props.receivedMessage.package.event;

        let props = {
            ...this.props,
            event: event
        };

        return <>
            <Modal
                id={'modal-primary'}
                show={this.state.show}
                onHide={this.hide}
                scrollable
                animation
                className={'event-modal'}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                contentClassName={'event-modal-content'}
            >
                <Modal.Header id={'modal-header'}
                              closeButton
                              className={'event-modal-header'}
                              onClick={this.hide}
                >
                    <Modal.Title id="contained-modal-title-vcenter">
                        {event.name}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className={'event-modal-body'}
                            onClick={this.hide}
                >
                    <this.props.eventComponent {...props}/>
                </Modal.Body>
                <Modal.Footer className={'event-modal-footer'}>
                    <AutoCloseButton
                        {...props}
                        eventComplete={this.eventComplete}
                    />
                </Modal.Footer>

            </Modal>
        </>;
    }

}
